import { ACTION_TYPE, AdgroupFormData, CampaignFormData, CreateMode, FullNormalFormData } from '@tt4b/ttam-enums';
import { computed, Ref } from '@vue/composition-api';
import {
  useCreativeAdgroupIs,
  useAllowlist,
  useStdCreativeAdgroupIs,
  useRequest,
  useRecommendUrlApi,
  useStdCreativeIs,
} from '@tt4b/ttam-hooks';

export function useInputPropsDisabled(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
  isDisabledCreative: Ref<boolean>;
  createMode: Ref<string>;
}) {
  const { adgroupData, campaignData, isDisabledCreative, createMode } = props;
  const { isAco } = useStdCreativeAdgroupIs({ campaignFormData: campaignData, adgroupFormData: adgroupData });
  const { isCreateInExistAcoAdgroup } = useCreativeAdgroupIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
    createMode,
  });

  const disabled = computed(() => {
    // 创意层级被disable || 在已有的aco adgroup下新建也禁用
    if (isDisabledCreative.value || isCreateInExistAcoAdgroup.value) {
      return true;
    }

    // URL在编辑场景下是否可以修改
    if (createMode.value === CreateMode.EDIT) {
      // 如果开白并且非aco的场景下，可以编辑
      if (!isAco.value) {
        return false;
      }

      // 禁止编辑
      return true;
    }

    // 可以编辑
    return false;
  });

  return {
    disabled,
  };
}

export * from './check-url/use-check-url';

export function useInitRecommUrl(props: { adgroupData: Ref<AdgroupFormData> }): { data: Ref<readonly string[]> } {
  const { adgroupData } = props;
  const { data } = useRequest(useRecommendUrlApi, {
    externalType: adgroupData.value.externalType,
  });

  return { data };
}
